import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Auth from './components/Auth/Auth';
import Dashboard from './pages/Dashboard/Dashboard';
import Partners from './pages/Partners/Partners';
import BatchApprovals from './pages/BatchApprovals/BatchApprovals';
import BidSelection from './pages/BidSelection/BidSelection';
import Settlements from './pages/Settlements/Settlements';
import Disputes from './pages/Disputes/Disputes';
import TraderDashboard from './pages/TraderDashboard/TraderDashboard';
import BuyerDashboard from './pages/BuyerDashboard/BuyerDashboard';
import BuyerMarketplace from './pages/BuyerMarketplace/BuyerMarketplace';
import TransporterDashboard from './pages/TransporterDashboard/TransporterDashboard';
import TransporterLoads from './pages/TransporterLoads/TransporterLoads';
import TransporterMyBids from './pages/TransporterMyBids/TransporterMyBids';
import TransporterTrips from './pages/TransporterTrips/TransporterTrips';
import TransporterTripDetail from './pages/TransporterTripDetail/TransporterTripDetail';
import TransporterProfile from './pages/TransporterProfile/TransporterProfile';
import UserProfile from './pages/UserProfile/UserProfile';
import TraderOrders from './pages/TraderOrders/TraderOrders';
import AdminOrders from './pages/AdminOrders/AdminOrders';
import DriverDashboard from './pages/DriverDashboard/DriverDashboard';
import DriverTrips from './pages/DriverTrips/DriverTrips';
import DriverProfile from './pages/DriverProfile/DriverProfile';
import { getUserRole } from './lib/directus';
import { useState } from 'react';

function ProtectedRoutes() {
  const role = getUserRole();

  if (role === 'Trader') {
    return (
      <Routes>
        <Route path="/dashboard" element={<TraderDashboard />} />
        <Route path="/orders"    element={<TraderOrders />} />
        <Route path="/profile"   element={<UserProfile />} />
        <Route path="*"          element={<Navigate to="/dashboard" replace />} />
      </Routes>
    );
  }

  if (role === 'Buyer') {
    return (
      <Routes>
        <Route path="/dashboard"   element={<BuyerDashboard />} />
        <Route path="/marketplace" element={<BuyerMarketplace />} />
        <Route path="/profile"     element={<UserProfile />} />
        <Route path="*"            element={<Navigate to="/dashboard" replace />} />
      </Routes>
    );
  }

  if (role === 'Driver') {
    return (
      <Routes>
        <Route path="/dashboard" element={<DriverDashboard />} />
        <Route path="/trips"     element={<DriverTrips />} />
        <Route path="/trips/:id" element={<TransporterTripDetail />} />
        <Route path="/profile"   element={<DriverProfile />} />
        <Route path="*"          element={<Navigate to="/dashboard" replace />} />
      </Routes>
    );
  }

  if (role === 'Transporter') {
    return (
      <Routes>
        <Route path="/dashboard" element={<TransporterDashboard />} />
        <Route path="/loads"     element={<TransporterLoads />} />
        <Route path="/my-bids"   element={<TransporterMyBids />} />
        <Route path="/trips"     element={<TransporterTrips />} />
        <Route path="/trips/:id" element={<TransporterTripDetail />} />
        <Route path="/profile"   element={<TransporterProfile />} />
        <Route path="*"          element={<Navigate to="/dashboard" replace />} />
      </Routes>
    );
  }

  if (role !== 'System Admin') {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: '16px',
        padding: '24px',
        textAlign: 'center',
        fontFamily: '"General Sans", sans-serif',
      }}>
        <img src="/driftwood-logo.png" alt="Driftwood Agri" style={{ height: 80, marginBottom: 8 }} />
        <p style={{ fontSize: 18, fontWeight: 500, color: '#161F26', margin: 0 }}>
          Access denied
        </p>
        <p style={{ fontSize: 14, color: '#969696', margin: 0, maxWidth: 300, lineHeight: 1.5 }}>
          Your account does not have permission to access this portal. Please contact your administrator.
        </p>
        <button
          onClick={() => { localStorage.clear(); window.location.replace('/login'); }}
          style={{
            marginTop: 8,
            padding: '10px 28px',
            borderRadius: 100,
            border: 'none',
            background: '#9DC0DC',
            fontSize: 14,
            fontWeight: 500,
            color: '#161F26',
            cursor: 'pointer',
          }}
        >
          Log out
        </button>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/dashboard"        element={<Dashboard />} />
      <Route path="/partners"         element={<Partners />} />
      <Route path="/batch-approvals"  element={<BatchApprovals />} />
      <Route path="/orders"           element={<AdminOrders />} />
      <Route path="/bid-selection"    element={<BidSelection />} />
      <Route path="/settlements"      element={<Settlements />} />
      <Route path="/disputes"         element={<Disputes />} />
      <Route path="*"                 element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('access_token'));

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated
              ? <Navigate to="/dashboard" replace />
              : <Auth onLogin={() => setIsAuthenticated(true)} />
          }
        />
        <Route
          path="*"
          element={
            isAuthenticated
              ? <ProtectedRoutes />
              : <Navigate to="/login" replace />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
